var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown, getTestId, isValidObject } from '@airtel/air-design-system';
import { forwardRef } from 'react';
export var DropdownWidgetComponent = forwardRef((props, ref) => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DropdownWidget' : _props$testID;
  var placeholder = props.placeholder,
    label = props.label,
    dropdownList = props.dropdownList,
    id = props.id,
    onUserAction = props.onUserAction,
    onSelectMetaData = props.onSelectMetaData,
    onInputPressMetaData = props.onInputPressMetaData,
    restProps = __rest(props, ["placeholder", "label", "dropdownList", "id", "onUserAction", "onSelectMetaData", "onInputPressMetaData"]);
  return _jsx(Dropdown, Object.assign({
    variant: "none",
    ref: ref,
    dropdownList: dropdownList,
    placeholder: placeholder,
    label: label
  }, restProps, {
    onSelectedHandler: (data, searchedTerm, item) => {
      var action = isValidObject(item === null || item === void 0 ? void 0 : item.onItemPressMetaData) && (item === null || item === void 0 ? void 0 : item.onItemPressMetaData) || isValidObject(onSelectMetaData) && onSelectMetaData;
      action && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, action), {
        data,
        searchedTerm,
        item
      }));
    },
    onFocus: () => {
      isValidObject(onInputPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onInputPressMetaData)));
    },
    readonlyOnPress: () => {
      isValidObject(onInputPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onInputPressMetaData)));
    }
  }, getTestId(testID)));
});
DropdownWidgetComponent.genericRendererKey = 'AirDropdownWidget';